import { FlexAligner, Tooltip, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { GamepadIllustration } from '@/pages/gamepadLayoutScreen/GamepadIllustration.tsx';
import { useGamepadContext } from '@/providers';
import { GamepadLayout } from '@/providers/gamepadProvider/gamepadLayout';
import { responsive } from '@/utils';

type GamepadLayoutScreenProps = {
  withTitle?: boolean;
};

export const GamepadLayoutScreen = ({ withTitle = true }: GamepadLayoutScreenProps) => {
  const { t } = useTranslation('cameraControl');
  const { gamepadId, isGamepadConnected } = useGamepadContext();
  return (
    <FlexAligner
      alignment='center'
      direction='column'
      gap={responsive.spacing['4xlarge']}
      fullWidth={false}
    >
      {withTitle && (
        <Tooltip tooltip={t('connectedGamepadId', { id: gamepadId })}>
          <Typography type='heading_large' disabled={!isGamepadConnected}>
            {t(isGamepadConnected ? 'gamepadLayout' : 'gamepadLayoutDisconnected')}
          </Typography>
        </Tooltip>
      )}
      <GamepadIllustration gamepadLayout={GamepadLayout} />
    </FlexAligner>
  );
};
